<template>
  <div class="packing-list">
    <home-nav-bar title="包装">
      <div slot="right" class="nav-bar-right">
        <div class="title" @click="createPacking">
          +增加包装
        </div>
      </div>
    </home-nav-bar>
    <wh-mobile-list ref="listTable" class="main" :extra-params="extraParams" data-src="/api/getPackingManagement">
      <template v-slot="{list}">
        <van-swipe-cell v-for="i in list" :key="i.id" :right-width="86">
          <div class="list-item">
            <div class="packing-info wh-flex-between" @click="edit(i)">
              <van-image
                class="img"
                width="60"
                height="60"
                :src="i.photo|firstImgThumb"
              />
              <div class="name-list">
                <div class="name wh-text-overflow">
                  {{ i.productName }}
                </div>
                <div class="wh-flex-between">
                  <div class="wh-text-overflow">
                    <div class="unit">
                      {{ i.specificationQuantity }}{{ i.specificationUint }}/{{ i.specificationPacking }}
                    </div>
                    <div>{{ i.processingJson.craftName }}</div>
                    <div>{{ i.rawMaterialsInventoryRecordsInfo?i.rawMaterialsInventoryRecordsInfo[0].materialName:'暂无原料' }}</div>
                  </div>
                  <div style="text-align: right">
                    <div class="count wh-text-overflow">
                      {{ i.packingQuantity }}{{ i.specificationPacking }}
                    </div>
                    <div class="staff">
                      操作人：{{ i.staffName }}
                    </div>
                    <div class="staff">
                      {{ formatTime(i.packingTime,'YYYY-MM-DD') }}
                    </div>
                  </div>
                </div>
              </div>
              <!--              <div class="staff">-->
              <!--              </div>-->
            </div>
            <router-link :to="{name:'TracePacking',query:{ traceCode : i.traceCode }}" class="trace">
              查看溯源
            </router-link>
          </div>
          <template #right>
            <van-button square text="删除" style="height:100%;width:86px" type="danger" @click="delPacking(i.id)" />
          </template>
        </van-swipe-cell>
      </template>
    </wh-mobile-list>
    <packing-popup
      :visible.sync="popup.packing.visible"
      :form-type="popup.packing.formType"
      :init-form-data="popup.packing.initFormData"
      @submitFormSuccess="submitFormSuccessFn"
    />
  </div>
</template>
<script>
import api from '@/api'
import { firstImgThumb } from '@/filter'
import { formatTime } from '@/utils/convert/convertTime'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import PackingPopup from '@/views/packing/components/PackingPopup'
export default {
  components: { HomeNavBar, WhMobileList, PackingPopup },
  filters: {
    firstImgThumb
  },
  data() {
    return {
      extraParams: {

      },
      popup: {
        packing: {
          visible: false,
          formType: 'create',
          initFormData: {}
        }
      }
    }
  },
  methods: {
    formatTime,
    createPacking() {
      this.popup.packing.visible = true
      this.popup.packing.formType = 'create'
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.$refs.listTable.onRefresh()
      }
    },
    edit(i) {
      this.popup.packing.visible = true
      this.popup.packing.formType = 'edit'
      this.popup.packing.initFormData = { ...i }
    },
    delPacking(i) {
      this.$dialog.confirm({
        title: '是否删除?'
      })
        .then(() => {
          const params = {
            id: i
          }
          api.deletePackingManagement(params).then(res => {
            this.$refs.listTable.onRefresh()
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>
<style lang="less" scoped>
.packing-list{
  height: 100%;
  display: flex;
  flex-direction: column;
  .nav-bar-right {
    .title{
      color: #20CAA0;
    }
  }
 .main{
   margin-top: 6px;
    .list-item{
    height: 130px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 8px;
    padding: 16px;
    .packing-info{
      font-size: 14px;
      .name-list{
        width: calc(100% - 90px);
        height: 100%;
        color: #BBBBBB;
        align-items: start;
          .name{
            color: #323332;
          }
          .unit{
            /*color: #20CAA0;*/
          }
          .staff{
            white-space: nowrap;
          }
          .count{
            display: inline-block;
            width: 46px;
            height: 16px;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #fff;
            background-color: #20CAA0;
            border-radius: 2px;
        }
        >div{
          line-height: 20px;
        }
      }
      .staff{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
    .trace{
      text-align: center;
      font-size: 14px;
      display: block;
      margin: 0 auto;
      line-height: 22px;
      width: 120px;
    }
  }
 }
}
</style>
